import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "confirmation-page"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "purchase-cart-heading"
};
const _hoisted_4 = {
  key: 0,
  class: "purchase-cart-heading-title"
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  class: "purchase-cart-heading"
};
const _hoisted_7 = {
  class: "purchase-cart-heading-title"
};
const _hoisted_8 = {
  class: "confirmation-page-body"
};
const _hoisted_9 = {
  class: "order-submitted-message"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  key: 2,
  class: "confirmation-data-table"
};
const _hoisted_13 = {
  class: "confirmation-data-header"
};
const _hoisted_14 = {
  class: "order-no"
};
const _hoisted_15 = {
  class: "purchase-order-no"
};
const _hoisted_16 = {
  class: "item-count"
};
const _hoisted_17 = {
  class: "total"
};
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "mod-exp"
}, null, -1);
const _hoisted_19 = {
  class: "confirmation-data-order"
};
const _hoisted_20 = {
  class: "order-no"
};
const _hoisted_21 = {
  class: "mobile-label"
};
const _hoisted_22 = {
  class: "order-info-wrapper"
};
const _hoisted_23 = ["href", "aria-label"];
const _hoisted_24 = {
  class: "mod-exp-mobile"
};
const _hoisted_25 = {
  key: 0,
  class: "pending-wrapper"
};
const _hoisted_26 = {
  class: "checkout-pending-icon-background"
};
const _hoisted_27 = {
  key: 1,
  class: "checkout-confirm-icon-background"
};
const _hoisted_28 = {
  class: "purchase-order-no"
};
const _hoisted_29 = {
  class: "mobile-label"
};
const _hoisted_30 = {
  class: "item-count"
};
const _hoisted_31 = {
  class: "mobile-label"
};
const _hoisted_32 = {
  class: "total"
};
const _hoisted_33 = {
  class: "mobile-label"
};
const _hoisted_34 = {
  class: "mod-exp"
};
const _hoisted_35 = {
  key: 0,
  class: "pending-wrapper"
};
const _hoisted_36 = {
  class: "checkout-pending-icon-background"
};
const _hoisted_37 = {
  key: 1,
  class: "checkout-confirm-icon-background"
};
const _hoisted_38 = {
  class: "button-wrapper"
};
const _hoisted_39 = ["aria-label"];
const _hoisted_40 = ["aria-label"];
const _hoisted_41 = {
  key: 3,
  class: "confirmation-failure-container"
};
const _hoisted_42 = {
  class: "confirmation-failure-msg"
};
const _hoisted_43 = {
  key: 0,
  class: "pdp-line-item-product-single-meta"
};
const _hoisted_44 = {
  key: 1
};
const _hoisted_45 = {
  key: 0,
  class: "pdp-line-item-product-single-meta"
};
const _hoisted_46 = {
  key: 1,
  class: "pdp-line-item-product-single-meta"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CheckoutPending = _resolveComponent("CheckoutPending");
  const _component_CheckoutConfirm = _resolveComponent("CheckoutConfirm");
  const _component_Tooltip = _resolveComponent("Tooltip");
  return _openBlock(), _createElementBlock("div", null, [_withDirectives(_createElementVNode("div", _hoisted_1, [$options.hasErrorDetails ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [$options.confirmationData.errorDetails?.errorCode === 'T' ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString($options.getLabel("order.checkout.timeout.errormessage")), 1)) : _createCommentVNode("", true)])])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("h2", _hoisted_7, _toDisplayString($options.getLabel("thanks.order.Sentence")), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString($options.getLabel("order.confirmation.orderInfo.your.order.successful")), 1), $options.confirmationData?.isAnyPending ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($options.getLabel("modified.experience.msg")), 1)) : $options.confirmationData?.isAllPending ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($options.getLabel("order.confirmation.orderInfo.your.order.all.pendingText")), 1)) : _createCommentVNode("", true), $options.hasConfirmationData ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString($options.getLabel("order.confirmation.orderNumber")), 1), _createElementVNode("span", _hoisted_15, _toDisplayString($options.getLabel("text.search.option.poNo")), 1), _createElementVNode("span", _hoisted_16, _toDisplayString($options.getLabel("order.management.order.items")), 1), _createElementVNode("span", _hoisted_17, _toDisplayString($options.getLabel("order.confirmation.total")), 1), _hoisted_18]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.orders, order => {
    return _openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString($options.getLabel("order.confirmation.orderNumber")), 1), _createElementVNode("div", _hoisted_22, [_createElementVNode("a", {
      class: "order-no-color",
      href: $data.orderLink + order.orderNo,
      "aria-label": $options.getLabel('order.detail.rightRail.vieworder')
    }, _toDisplayString(order.orderNo), 9, _hoisted_23), _createElementVNode("span", _hoisted_24, [order.nonRealTime ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(_component_CheckoutPending)]), _createElementVNode("span", null, _toDisplayString(order.showPickupDateLabel ? $options.getLabel('pickup.date.pending') : $options.getLabel('delivery.date.pending')), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_CheckoutConfirm)]))])])]), _createElementVNode("span", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString($options.getLabel("text.search.option.poNo")), 1), _createTextVNode(" " + _toDisplayString(order.purchaseOrderNo), 1)]), _createElementVNode("span", _hoisted_30, [_createElementVNode("div", _hoisted_31, _toDisplayString($options.getLabel("order.management.order.items")), 1), _createTextVNode(" " + _toDisplayString(order.itemCount), 1)]), _createElementVNode("span", _hoisted_32, [_createElementVNode("div", _hoisted_33, _toDisplayString($options.getLabel("order.confirmation.total")), 1), _createTextVNode(" " + _toDisplayString($options.getFormattedTotal(order)), 1)]), _createElementVNode("span", _hoisted_34, [order.nonRealTime ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createVNode(_component_CheckoutPending)]), _createElementVNode("span", null, _toDisplayString(order.showPickupDateLabel ? $options.getLabel('pickup.date.pending') : $options.getLabel('delivery.date.pending')), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_37, [_createVNode(_component_CheckoutConfirm)]))])]);
  }), 256))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_38, [_createElementVNode("button", {
    class: "view-orders-button confirmation-button",
    "aria-label": $options.getLabel('order.detail.rightRail.vieworders'),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.viewOrders && $options.viewOrders(...args))
  }, _toDisplayString($data.orderText), 9, _hoisted_39), !$options.hasReturnedLineItems ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "reorder-button",
    "aria-label": $options.getLabel('reorder.Title'),
    onClick: _cache[1] || (_cache[1] = (...args) => $options.reOrder && $options.reOrder(...args))
  }, _toDisplayString($data.reOrderText), 9, _hoisted_40)) : _createCommentVNode("", true)]), $options.hasReturnedLineItems ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("p", _hoisted_42, _toDisplayString($options.getLabel("ordercreate.failed.message")), 1), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.confirmationData?.returnedLineItems, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index
    }, [_createElementVNode("p", null, [$options.ifValueExists(item.myPartDescription) ? (_openBlock(), _createElementBlock("span", _hoisted_43, [_createVNode(_component_Tooltip, {
      passedText: item.salesText
    }, null, 8, ["passedText"]), _createElementVNode("span", null, _toDisplayString(item.myPartDescription), 1)])) : (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(item.salesText), 1)), _createElementVNode("span", null, [$options.ifValueExists(item.myPartNumber) ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_createVNode(_component_Tooltip, {
      passedText: $options.getMaterialNumberLabel(item.materialNumber)
    }, null, 8, ["passedText"]), _createElementVNode("span", null, _toDisplayString($options.getLabel("part.number.Title")) + " " + _toDisplayString(item.myPartNumber), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString($options.getMaterialNumberLabel(item.materialNumber)), 1))])])]);
  }), 128))])])) : _createCommentVNode("", true)])]))], 512), [[_vShow, !$data.loading]])]);
}